import { render, staticRenderFns } from "./riskdrawer.vue?vue&type=template&id=3f44050f&scoped=true&"
import script from "./riskdrawer.vue?vue&type=script&lang=js&"
export * from "./riskdrawer.vue?vue&type=script&lang=js&"
import style0 from "./riskdrawer.vue?vue&type=style&index=0&id=3f44050f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f44050f",
  null
  
)

export default component.exports